<script lang="ts">
	import { onMount } from 'svelte'
	import { swipe, type SwipeCustomEvent } from 'svelte-gestures'
	import type { i18n } from 'types/common'
	import { getContext } from 'svelte'
	const { t: translate } = getContext<i18n>('i18next')

	interface Props {
		altTitle: string
		selectedImage: { name: string; path: string } | null
		images: Array<{ name: string; path: string }>
	}

	let { selectedImage = $bindable(), images, altTitle }: Props = $props()

	let selectedImageIndex = $state(0)
	let previousImageIndex = $derived(selectedImageIndex - 1)
	let nextImageIndex = $derived(selectedImageIndex + 1)

	function swipeHandler(event: SwipeCustomEvent) {
		const direction = event.detail.direction
		if (direction === 'left') {
			changePhoto('next')
		} else if (direction === 'right') {
			changePhoto('previous')
		}
	}

	function changePhoto(direction: 'next' | 'previous') {
		if (direction === 'next' && selectedImageIndex < images.length - 1) {
			selectedImageIndex = nextImageIndex
		} else if (direction === 'previous' && selectedImageIndex > 0) {
			selectedImageIndex = previousImageIndex
		}
	}

	onMount(() => {
		if (selectedImage) {
			const index = images.findIndex(image => image.path === selectedImage.path)
			if (index !== -1) {
				selectedImageIndex = index
			}
		}
	})
</script>

<div class="d-flex flex-column align-items-center">
	<div
		id="carousel-indicators"
		class="carousel slide"
		data-ride="carousel"
	>
		<button
			class="carousel-control-prev"
			onclick={() => changePhoto('previous')}
		>
			<!--
				I used w-50 here to scale down the icon a little, 
				it seems like it was controlled by width x height in the css class 
			-->
			<span
				class="carousel-control-prev-icon w-50"
				aria-hidden="true"
			></span>
			<span class="sr-only">{translate('imageViewer.previous', 'Previous')}</span>
		</button>
		<button
			class="carousel-control-next"
			onclick={() => changePhoto('next')}
		>
			<span
				class="carousel-control-next-icon w-50"
				aria-hidden="true"
			></span>
			<span class="sr-only">{translate('common:next', 'Next')}</span></button
		>
		<div
			class="carousel-inner"
			use:swipe={() => ({})}
			onswipe={swipeHandler}
		>
			<a
				target="_blank"
				href={images[selectedImageIndex].path}
				style="height: min-content;"
			>
				<img
					class="img-fluid rounded img-thumbnail p-0"
					src="{images[selectedImageIndex].path}?height=240&width=240&fit=contain"
					title={images[selectedImageIndex].name}
					alt={altTitle}
				/>
			</a>
		</div>
	</div>
	<div
		class="mt-1 d-flex flex-nowrap overflow-auto"
		style="max-width: 100%; scrollbar-width: thin;"
	>
		{#each images as imageData, index}
			<button
				id={`image-preview-thumbnail-${index}`}
				type="button"
				class="btn p-0"
				class:border-primary={index === selectedImageIndex}
				class:border-none={index !== selectedImageIndex}
				aria-label={`Show image ${imageData.name}`}
				onclick={() => {
					selectedImageIndex = index
					document
						.getElementById(`image-preview-thumbnail-${index}`)
						?.scrollIntoView({ block: 'nearest', inline: 'center' })
				}}
			>
				<img
					class="img-fluid p-1"
					style="min-width: 20px; max-width: 40px;"
					src="{imageData.path}?height=40&width=40&fit=contain"
					title={imageData.name}
					alt={altTitle}
				/>
			</button>
		{/each}
	</div>
</div>
